import { render, staticRenderFns } from "./form_data.vue?vue&type=template&id=95f30e66&scoped=true&"
import script from "./form_data.vue?vue&type=script&lang=js&"
export * from "./form_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f30e66",
  null
  
)

export default component.exports